define(
  'SuiteCommerce.OrderStatus.Instrumentation.MockAppender', [],
  function define() {
    'use strict';

    return  {
     info : function info(data) {
        console.info('MockAppender - Info', data);
      },

      error : function error(data) {
        console.error('MockAppender - Error', data);
      },

      ready : function ready() {
        return true;
      },

      getInstance : function getInstance() {
        if (!this.instance) {
          this.instance = this;
        }
        return this.instance;
      },

      start : function start(action, options) {
        return options;
      },

      end : function end(startOptions, options) {}
    };

  });
